//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class CashCategoryDisplayItem extends ItemBase {
    ID: string | null = null;
    LegacyID: number = 0;     // OBSOLETE - Use only for compatibility
    SchoolID: string | null = null;
    Name: string | null = null;
    UserGenerated: boolean = false;
    IsExpense: boolean = false;
    PrimaryCategory: boolean = false;
    Active: boolean = false;
    CashCount: number | null = null;

    constructor(initializer?: Partial<CashCategoryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashCategoryDisplayItem";
}
